import * as _ from 'lodash';
import * as actions from '../constants/map';

export const setFullscreen = (isFullscreen) => dispatch => {
  dispatch({ type: actions.SET_FULLSCREEN, data: { isFullscreen } });
}